import React, { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { SelectButton } from 'primereact/selectbutton';

export default function Panel_B({ dataTable, setDataTable, onUploadDialog, uploadPic, disabledPage }) {
    // useEffect(() => {

    // }, [dataTable]);

    const onInputTextChange = (e, key, id) => {
        const val = (e.target && e.target.value) || "";

        const newList = [...dataTable];
        const editIndex = newList.findIndex((item) => {
            return item.inspectId === id;
        });

        if (editIndex > -1) {
            let newData = newList[editIndex];
            newData = {
                ...newData,
                [`${key}`]: val,
            };

            newList[editIndex] = newData;

            setDataTable(newList);
        }
    };

    const [divColor, setDivColor] = useState({ color: "white", key: 0 });

    const _hover = (_key) => {
        setDivColor({ key: _key, color: "#e9ecef" });
    };
    const _out = (_key) => {
        setDivColor({ key: _key, color: "white" });
    };

    const display_mode = () => {
        if (dataTable) return dataTable[0].displayMode === "Y" ? true : false;
    };

    const justifyOptions = [
        { icon: 'pi pi-align-left', label: 'งานเรียบร้อย', value: '1' },
        { icon: 'pi pi-align-right', label: 'ควรปรับปรุง', value: '2' },
        { icon: 'pi pi-align-center', label: 'ไม่ถูกต้อง/ให้แก้ไข', value: '3' },
        { icon: 'pi pi-align-justify', label: 'ไม่ดำเนินการครั้งนี้', value: '4' }
    ];

   
    const renderInspect = () => {
        // console.log('dataTable ',dataTable);
        return dataTable.map((item, index) => {
            return (
                <div className="p-grid p-fluid" style={{ backgroundColor: divColor.key === index ? divColor.color : "white" }} key={index} onMouseOver={() => _hover(index)} onMouseOut={() => _out(index)}>
                    <div className="p-col-12 p-md-4">{item.inspectDesc}</div>
                    <div className="p-col-12 p-md-5">
                        <div className="flex justify-content-center">
                            <SelectButton 
                            optionLabel="label" 
                            options={justifyOptions} 
                            value={item.inspectResult}
                            onChange={(e) => onInputTextChange(e, "inspectResult", item.inspectId)}
                            optionValue="value"
                            disabled={disabledPage}/>
                        </div>
                        {/* <div className="p-grid">
                            <div className="p-col-12 p-md-3">

                                <div className="p-field-radiobutton">
                                    <RadioButton
                                        inputId={item.inspectId + "_1"}
                                        name={item.inspectId + "_" + item.inspectId}
                                        id={item.inspectId + "_1"}
                                        value="1"
                                        key={item.inspectId + "_1"}
                                        checked={item.inspectResult === "1" ? true : false}
                                        onChange={(e) => onInputTextChange(e, "inspectResult", item.inspectId)}
                                        disabled={disabledPage}
                                    />
                                    <label htmlFor={item.inspectId + "_1"}>งานเรียบร้อย</label>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-3">
                                <div className="p-field-radiobutton">
                                    <RadioButton
                                        inputId={item.inspectId + "_2"}
                                        name={item.inspectId + "_" + item.inspectId}
                                        id={item.inspectId + "_2"}
                                        value="2"
                                        key={item.inspectId + "_2"}
                                        checked={item.inspectResult === "2" ? true : false}
                                        onChange={(e) => onInputTextChange(e, "inspectResult", item.inspectId)}
                                        disabled={disabledPage}
                                    />
                                    <label htmlFor={item.inspectId + "_2"}>ควรปรับปรุง</label>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-3">
                                <div className="p-field-radiobutton">
                                    <RadioButton
                                        inputId={item.inspectId + "_3"}
                                        name={item.inspectId + "_" + item.inspectId}
                                        id={item.inspectId + "_3"}
                                        value="3"
                                        key={item.inspectId + "_3"}
                                        checked={item.inspectResult === "3" ? true : false}
                                        onChange={(e) => onInputTextChange(e, "inspectResult", item.inspectId)}
                                        disabled={disabledPage}
                                    />
                                    <label htmlFor={item.inspectId + "_3"}>ไม่ถูกต้อง/ให้แก้ไข</label>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-3">
                                <div className="p-field-radiobutton">
                                    <RadioButton
                                        inputId={item.inspectId + "_4"}
                                        name={item.inspectId + "_" + item.inspectId}
                                        id={item.inspectId + "_4"}
                                        value="4"
                                        key={item.inspectId + "_4"}
                                        checked={item.inspectResult === "4" ? true : false}
                                        onChange={(e) => onInputTextChange(e, "inspectResult", item.inspectId)}
                                        disabled={disabledPage}
                                    />
                                    <label htmlFor={item.inspectId + "_4"}>ไม่ดำเนินการครั้งนี้</label>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <div className="p-inputgroup">
                            <InputText disabled={disabledPage} placeholder="หมายเหตุ" id={"inspectRemark_" + item.inspectId} type="text" value={item.inspectRemark} maxLength="500" onChange={(e) => onInputTextChange(e, "inspectRemark", item.inspectId)} />
                        </div>
                    </div>

                    <div className="p-col-12 p-md-1">
                        {item.inspectResult !== null && item.inspectResult !== " " && !display_mode() ? (
                            <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic(`T2${item.seqPk}`)} />
                        ) : (
                            <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                        )}
                        {item.inspectResult !== null && item.inspectResult !== " " ? (
                            <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog(`T2${item.seqPk}`)} />
                        ) : (
                            <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                        )}

                        {/* <Button
                            className="p-button-info p-button p-md-12 "
                            icon="pi pi-image"
                            label="รูปถ่าย"
                            onClick={() => onUploadDialog(`T2${item.seqPk}`)}
                            // onClick={() => submitForm()}
                        /> */}
                    </div>
                </div>
            );
        });
    };

    return (
        <div>
            <div className="p-grid p-fluid">
                <div className="p-col-12">
                    <h5 className="p-no-box line-under">
                        <b>การตรวจสอบงานก่อสร้าง</b>

                    </h5>
                    {renderInspect()}
                </div>
            </div>
        </div>
    );
}
